module.exports = __webpack_public_path__ + "static/power-img3-3@2x-71a9ff61a1c2f50237e07106253d4ae9.png";